<!-- =========================================================================================
  File Name: InviteManagerSidebar.vue
  Description: Add New Manager Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isManagerSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h5>ADD MANAGER FOR:</h5>
         <vs-chip  color="primary" class="mr-8">
      <p >{{dataLocationName}}</p>
    </vs-chip>
        <feather-icon icon="XIcon" @click.stop="isManagerSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <vs-row>
    <vs-col vs-w="12">
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6" >
        <div class="flex">
          <vs-checkbox v-model="NewBox" @change="newcheck(NewBox)">Add New</vs-checkbox>
        </div>
        <br>
        <div v-if="ExBox">
        <label class="vs-select--label w-full">Select Existing manager</label>
        <v-select  v-if="ExBox" label="name"  multiple :closeOnSelect="true" v-model="dataManager"  :options="managers"   />
        </div>

      </div>
      <div class="pl-6 pr-6 " v-if="NewBox">
         <template >

          <!-- Image Container -->
         <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">

            <img v-if="checkImg" :src="dataImg" class="responsive">
          </div>
          </div>
            </div>
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click.native="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} Image</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click.native="ImgName = null , dataImg = null">Remove Image</vs-button>
          </div>
        </template>

        <!-- FIRST NAME -->
        <vs-input label="First Name *" v-model="dataFirstName" class="mt-5 w-full" name="firstName" v-validate="'required'"/>

        <!-- LAST NAME -->
        <vs-input label="Last Name *" v-model="dataLastName" class="mt-5 w-full" name="lastName" v-validate="'required'"/>
        <!-- NICK NAME -->
        <vs-input label="Nickname" v-model="dataNickName" class="mt-5 w-full" name="Nick Name" />
        <!-- Username -->
        <vs-input label="Username *"  v-model="dataUserName" @input="checkUserName" class="mt-5 w-full" name="UserName"  v-validate="'alpha_num'"/>
        <span class="text-danger text-sm" v-show="errors.has('UserName')">{{ errors.first('UserName') }}</span>

        <span class="text-danger text-sm" v-if="UserDuplicate>0">Username has already been taken !</span>
        <!-- EMAIL -->
        <vs-input label="Email *" v-model="dataEmail" @input="checkUserEmail" class="mt-5 w-full" name="email"
                  v-validate="'email|required'"/>
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        <span class="text-danger text-sm" v-if="emailDuplicate>0">Email has already been taken !</span>

        <!-- PHONE -->
        <vs-input label="Phone"  v-model="dataPhone" @input="acceptNumber" class="mt-5 w-full" name="phone"/>
        <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
        <span v-if="dataPhone.length > 0 &&  dataPhone.length < 14" class="text-danger text-sm">Invalid phone number format.</span>
        <br>
        <vs-checkbox v-model="dataEmailInviteOption"
                     @change="changeEmailConfirmationStatus(dataEmailInviteOption)">Send Invite Email
        </vs-checkbox>
        <div v-if="!dataEmailInviteOption">
        <vs-input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:20'"
          name="password"
          label-placeholder="Password"
          placeholder="Password"
          v-model="dataPassword"
          class="w-full mt-6" />
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>

        <vs-input
          type="password"
          v-validate="'min:6|max:20|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm_password"
          label-placeholder="Confirm Password"
          placeholder="Confirm Password"
          v-model="dataConfPassword"
          class="w-full mt-6" />
        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

        </div>
          <br>

        <!-- STATUS -->
        <vs-row vs-w="12" class="ml-6">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="2" vs-xs="1">
            <label>Status</label>
          </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="9">
        </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">
          <vs-switch v-model="dataStatus"></vs-switch>
        </vs-col>
        </vs-row>

      </div>
    </component>
     </vs-col>
    </vs-row>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">{{ $t('user.add.btn_submit') }}</vs-button>
      <vs-button type="border" color="danger" @click.native="isManagerSidebarActiveLocal = false">{{ $t('user.add.btn_cancel') }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'
import vSelect from 'vue-select'

import {
  ALL_MANAGERS,
  UPDATE_LOCATION,
  CHECK_USER_EMAIL,
  CREATE_MANAGER,
  SINGLE_USER_BY_EMAIL,
  SINGLE_USER_BY_USERNAME,
  CHECK_USER_NAME_EXCEPT_ID, UPLOAD_IMAGE
} from '@/graphql'

export default {
  props: {
    isManagerSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      Duplicate:0,
      UserDuplicate:0,
      alphanumeric:0,
      ExBox:true,
      NewBox:false,
      dataId: null,
      dataLocationName:'',
      managers:[],
      dataManager:[],
      ImgName:'',
      dataImg:'',
      oldimage:'',
      dataFirstName: '',
      dataLastName: '',
      dataNickName: '',
      dataUserName: '',
      dataEmail: '',
      dataPhone: '',
      checkImg:'',
      dataLocation: [],
      dataStatus: true,
      dataPassword: '',
      dataConfPassword: '',
      dataEmailConfirmed: false,
      dataEmailInviteOption: true,
      PassField: true,
      enableInvitOption: true,
      UserDuplicate: 0,
      emailDuplicate: 0,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isManagerSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, managers, name} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataManager = managers
        this.dataLocationName = name
        const getmanagers = []
        const getmanagersids = []
        for (let j = 0; j < managers.length; j++) {
          getmanagersids.push(managers[j].id)
          const getfullname = `${managers[j].fname} ${managers[j].lname} - ${managers[j].email}`
          managers[j].name = getfullname
          getmanagers.push(managers[j])
        }
        this.dataManager = getmanagers
      }
    }
  },
  computed: {
    isManagerSidebarActiveLocal: {
      get () {
        return this.isManagerSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeManagerSidebar')
          // this.$validator.reset()
          this.ExBox = true
          this.NewBox = false
          this.initValues()
        }
      }
    },
    isFormValid () {
      if (this.ExBox) {
        return !this.errors.any() && this.dataManager.length > 0
      }
      if (this.NewBox) {
        if (this.dataEmailInviteOption) {
          return !this.errors.any() && this.dataEmail && this.dataFirstName && this.dataLastName && this.dataUserName  && this.UserDuplicate === 0 && this.emailDuplicate === 0 && (this.dataPhone == '' || this.dataPhone.length == 14)
        }
        if (!this.dataEmailInviteOption) {
          return !this.errors.any() && this.dataEmail && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataPassword && this.UserDuplicate === 0 && this.emailDuplicate === 0 && (this.dataPhone == '' || this.dataPhone.length == 14)
        }
      //  return !this.errors.any() && this.dataCamFirstName && this.dataCamLastName && this.dataCamEmail && this.Duplicate===0 && this.UserDuplicate===0 && this.alphanumeric===0 && (this.dataCamPhone =='' || this.dataCamPhone.length ==14)
      }

    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      this.dataManager = []
      this.enableInvitOption = false
      this.dataImg = '',
      this.ImgName = null,
      this.oldimage = '',
      this.dataFirstName = ''
      this.dataLastName = ''
      this.dataNickName = ''
      this.dataUserName = ''
      this.dataLocation = []
      this.dataStatus = true
      this.dataEmailConfirmed = false
      this.dataEmail = ''
      this.dataPhone = ''
      this.dataPassword = ''
      this.dataConfPassword = ''
      this.checkImg = ''
      this.ExBox = true
      this.NewBox = false
    },

    StatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Location',
        text:  'Manager added successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    submitData () {
      if (this.NewBox) {
        this.$validator.validateAll().then(result => {
          if (result) {
            const locations = []
            locations.push(this.dataId)
            this.$apollo
              .mutate({
                mutation: CREATE_MANAGER,
                variables: {
                  avatar: this.ImgName,
                  fname: this.dataFirstName,
                  lname: this.dataLastName,
                  nick_name: this.dataNickName,
                  username: this.dataUserName,
                  phone: this.dataPhone,
                  email: this.dataEmail,
                  status: this.dataStatus,
                  email_confirmed:true,
                  locations,
                  invite_email :this.dataEmailInviteOption,
                  password: this.dataPassword
                }
              }).then(response => {
                if (response.data.createManager.status == 'SUCCESS') {
                  this.StatusSuccess()
                  this.$validator.reset()
                  this.initValues()
                  this.$emit('closeManagerSidebar')
                  this.$emit('getdata', true)

                } else if (response.data.createManager.status == 'MUST_VERIFY_EMAIL') {
                  this.StatusSuccess()
                  this.$validator.reset()
                  this.initValues()
                  this.$emit('closeManagerSidebar')
                  this.$emit('getdata', true)

                }
              }).catch(error => {
                console.log(error)
              })
          }
        })
      }
      if (this.ExBox) {
        this.$validator.validateAll().then(result => {
          const getmanagerids = []
          for (let j = 0; j < this.dataManager.length; j++) {
            const getid = this.dataManager[j].id
            getmanagerids.push(getid)
          }
          if (result) {
            this.$apollo
              .mutate({
                mutation: UPDATE_LOCATION,
                variables: {
                  id:this.dataId,
                  name:this.dataLocationName,
                  managers: getmanagerids
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess()
                  this.$emit('closeManagerSidebar')
                  this.$emit('getdata', true)
                  this.$validator.reset()
                  this.initValues()
                }
              }).catch(error => {
                console.log(error)
              })
          }
        }
        )
      }
    },
    excheck (val) {
      this.NewBox = !val
    },
    newcheck (val) {
      this.ExBox = !val
    },
    openLoadingInDiv () {
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    checkUserName () {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkUserNameExcepteId()
      } else {
        this.checkUserNameWithoutId()
      }
    },
    checkUserNameExcepteId () {
      const letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else if (this.dataUserName) {
        this.$apollo
          .mutate({
            mutation: CHECK_USER_NAME_EXCEPT_ID,
            variables: {
              id: this.dataId,
              username: this.dataUserName
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.checkUserNameExceptId.length
          })
      }
    },
    checkUserNameWithoutId () {
      const letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else if (this.dataUserName) {
        this.$apollo
          .mutate({
            mutation: SINGLE_USER_BY_USERNAME,
            variables: {
              username: this.dataUserName
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.userByUserName.length
          })
      }
    },

    checkUserEmail () {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkEmailExceptId()
      } else {
        this.checkEmailWithoutId()
      }
    },

    checkEmailExceptId () {
      this.$apollo
        .mutate({
          mutation: CHECK_USER_EMAIL,
          variables: {
            id: this.dataId,
            email: this.dataEmail
          }
        })
        .then(response => {
          this.emailDuplicate = response.data.checkUserEmail.length
        })
    },
    checkEmailWithoutId () {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.dataEmail
          }
        })
        .then(response => {
          this.emailDuplicate = response.data.userByEmail.length
        })
    },
    acceptNumber () {
      const x = this.dataPhone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.dataPhone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    changeEmailConfirmationStatus (val) {
      this.dataEmailConfirmed = !val
      this.dataPassword = ''
      this.dataConfPassword = ''
    },
    changeInviteEmailStatus (val) {
      this.dataEmailInviteOption = !val
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        this.checkImg = 'somthing'
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
          this.openLoadingInDiv()
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image:this.dataImg,
                oldimage:this.oldimage
              }
            })
            .then(response => {
              if (response) {
                this.oldimage = ''
                if (response.data.uploadImage.status == 'SUCCESS') {
                  this.ImgName = response.data.uploadImage.image_name
                  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                } else {
                  this.ImgName = response.data.uploadImage.image_name
                  this.UploadFail(response.data.uploadImage.error)
                  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                }

              }
            }).catch(error => {
              console.log(error)
            })
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
  created () {
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    this.$apollo
    this.$apollo
      .mutate({
        mutation: ALL_MANAGERS
      })
      .then(response => {
        this.managers = response.data.role.users
        const managers = []
        for (let i = 0; i < response.data.role.users.length; i++) {
           if(response.data.role.users[i].status){
          const fullname = `${response.data.role.users[i].fname} ${response.data.role.users[i].lname} - ${response.data.role.users[i].email}`
          response.data.role.users[i].name = fullname
          managers.push(response.data.role.users[i])
          }
        }
        this.managers = managers
      })
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
